import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { ColoredBulletsProsAndCons } from './ColoredBullets';
import { DefaultProsAndCons } from './Default';
import { PanelProsAndCons } from './Panel';

type Props = {
  prosList?: string[] | StructuredContentDocument[];
  consList?: string[] | StructuredContentDocument[];
  variant?: 'default' | 'colored-bullets' | 'panel';
};

export const ProsAndCons = ({ prosList, consList, variant = 'default' }: Props) => {
  if (variant === 'default') {
    return <DefaultProsAndCons prosList={prosList} consList={consList} />;
  }

  if (variant === 'panel') {
    return <PanelProsAndCons prosList={prosList} consList={consList} />;
  }

  return <ColoredBulletsProsAndCons prosList={prosList} consList={consList} />;
};
